import {createFileRoute} from '@tanstack/react-router'
import {secondLevelIndexRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg/browse/$primarySorting/$primaryCategoryName/')({
    ...secondLevelIndexRoute("/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
})
